import { FC, ReactNode } from 'react'
import { Space } from 'antd'
import { useGetCurrencyRatesQuery } from '../../../../store/api/currency-rate'
import { DollarOutlined, EuroOutlined } from '@ant-design/icons'

interface CurrencyRatesProps {}

const CurrencyRates: FC<CurrencyRatesProps> = () => {
    const { data = [] } = useGetCurrencyRatesQuery()

    const icons: { [k: string]: ReactNode } = {
        EUR: <EuroOutlined style={{ fontSize: 16 }} />,
        USD: <DollarOutlined style={{ fontSize: 16 }} />,
    }

    return (
        <Space size={12}>
            {data?.map(x => (
                <div key={x.code}>
                    {icons[x.code]} {x.rate.toFixed(2)}
                </div>
            ))}
        </Space>
    )
}

export default CurrencyRates
